// extracted by mini-css-extract-plugin
export var form = "styles-module__form___hpvNC";
export var input = "styles-module__input___Kdy1s";
export var btn = "styles-module__btn___q__GY";
export var icon = "styles-module__icon___YazfS";